import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, } from '@tanstack/react-router';
export const Route = createFileRoute('/')({
    component: HomeComponent,
});
function HomeComponent() {
    return (_jsx("div", { className: "p-2", children: _jsx("h3", { children: "Welcome Home!" }) }));
}
//# sourceMappingURL=index.js.map